"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomCheckBox = CustomCheckBox;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const formik_1 = require("formik");
const _1 = require("./");
const index_1 = require("./../index");
const Separator_1 = require("./../Layout/Separator");
const Label_1 = require("./Label");
const CheckboxWrapper = styled_components_1.default.div `
  height: 30px;
  display: flex;
  padding-top: 4px;
`;
function CustomCheckBox({ name, label, disabled, showSeparator, }) {
    const [props, meta, helpers] = (0, formik_1.useField)({
        name: name,
        required: true,
        disabled,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Label_1.MultiLineLabel, { label: label, name: name, disabled: disabled, required: false }),
        react_1.default.createElement(CheckboxWrapper, null,
            react_1.default.createElement(index_1.ToggleCheckBox, { onChange: () => {
                    helpers.setValue(!props.value);
                }, checked: props.value, name: props.name, id: props.name, disabled: disabled, label: label }),
            showSeparator && (react_1.default.createElement(index_1.Flex, { flex: "1", height: "22px" },
                react_1.default.createElement(Separator_1.Separator, { grow: true })))),
        meta.error && meta.touched && react_1.default.createElement(_1.FieldError, null, meta.error)));
}
//# sourceMappingURL=CustomCheckBox.js.map